import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';
import {
  PRIMARY_THEMES,
  WORLD_CREATION_TYPES,
  SOCIAL_HIERARCHIES,
  CURRENCY_TYPES,
  TECHNOLOGY_LEVELS,
  defaultOptionValue
} from '../../../constants/global-context.constants';

@Component({
    selector: 'app-global-context-step',
    templateUrl: './global-context-step.component.html',
    styleUrls: ['./global-context-step.component.scss'],
    standalone: false
})
export class GlobalContextStepComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  themes = PRIMARY_THEMES;
  creationTypes = WORLD_CREATION_TYPES;
  hierarchies = SOCIAL_HIERARCHIES;
  currencies = CURRENCY_TYPES;
  techLevels = TECHNOLOGY_LEVELS;

  mapName = '';

  // Form Fields
  description = '';
  selectedThemes = defaultOptionValue(this.themes);
  selectedCreationType = defaultOptionValue(this.creationTypes);
  selectedHierarchy = defaultOptionValue(this.hierarchies);
  selectedCurrency = defaultOptionValue(this.currencies);
  selectedTech = defaultOptionValue(this.techLevels);

  // Validation
  showErrorMsg = false;
  validationErrorText = '';

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';

      // Restore values from state if they exist
      if (state.globalContext) {
        const gc = state.globalContext;
        this.description = gc.description || '';
        this.selectedThemes = gc.primaryThemes || defaultOptionValue(this.themes);
        this.selectedCreationType = gc.creationType || defaultOptionValue(this.creationTypes);
        this.selectedHierarchy = gc.socialHierarchy || defaultOptionValue(this.hierarchies);
        this.selectedCurrency = gc.currencyType || defaultOptionValue(this.currencies);
        this.selectedTech = gc.technologyLevel || defaultOptionValue(this.techLevels);
      }
      this.cdr.detectChanges();
    });
  }

  onNext(): void {
    this.showErrorMsg = false;
    this.validationErrorText = '';

    // Validate fields
    if (!this.description.trim()) {
      this.validationErrorText = 'World Description is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedThemes) {
      this.validationErrorText = 'Primary Themes/Tone is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedCreationType) {
      this.validationErrorText = 'World Creation Type is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedHierarchy) {
      this.validationErrorText = 'Social Hierarchy is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedCurrency) {
      this.validationErrorText = 'Currency Type is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.selectedTech) {
      this.validationErrorText = 'Technology Level is required.';
      this.showErrorMsg = true;
      return;
    }

    // Save state
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        description: this.description,
        primaryThemes: this.selectedThemes,
        creationType: this.selectedCreationType,
        socialHierarchy: this.selectedHierarchy,
        currencyType: this.selectedCurrency,
        technologyLevel: this.selectedTech
      }
    });

    this.next.emit();
  }

  onBack(): void {
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        description: this.description,
        primaryThemes: this.selectedThemes,
        creationType: this.selectedCreationType,
        socialHierarchy: this.selectedHierarchy,
        currencyType: this.selectedCurrency,
        technologyLevel: this.selectedTech
      }
    });
    this.back.emit();
  }
}
